import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Lock, Sparkles } from 'lucide-react';

export const StocksView = () => {
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="space-y-12" data-testid="stocks-view">
      <section className="space-y-4">
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#ff9e00]/10 border border-[#ff9e00]/20 rounded-full">
          <TrendingUp className="w-3 h-3 text-[#ff9e00] shrink-0" />
          <span className="font-mono text-[10px] text-[#ff9e00] tracking-widest font-semibold uppercase">05 // MARKET MATRIX</span>
        </div>
        <div className="max-w-2xl space-y-2">
          <h2 className="font-display font-black text-3xl sm:text-4xl text-white tracking-tight uppercase">Stocks Watchlist</h2>
          <p className="text-slate-400 text-xs sm:text-sm font-light leading-relaxed">
            Personalised market intelligence module. Pre-launch &mdash; reserved for authenticated operators only.
          </p>
        </div>
      </section>

      <section className="glass-card rounded-xl border border-slate-800 p-10 md:p-16 text-center space-y-6 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-[#ff9e00]/5 to-transparent blur-3xl pointer-events-none" />
        <div className="relative space-y-6">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-slate-900 border border-slate-800 mx-auto">
            <Lock className="w-7 h-7 text-[#ff9e00]" />
          </div>
          <div className="space-y-2">
            <div className="inline-flex items-center gap-1.5 px-2 py-0.5 bg-[#ff9e00]/10 border border-[#ff9e00]/25 rounded text-[9px] font-mono font-semibold text-[#ff9e00] uppercase">
              <Sparkles className="w-2.5 h-2.5" />
              COMING SOON
            </div>
            <h3 className="font-display font-black text-2xl text-white uppercase tracking-tight">
              Market Telemetry Engine
            </h3>
            <p className="text-xs sm:text-sm text-slate-400 max-w-lg mx-auto leading-relaxed font-light">
              A real-time watchlist with AI-distilled buy/sell signals, sector heatmaps, and personalised
              portfolio rebalancing recommendations. Currently in private architecture review.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl mx-auto pt-4 border-t border-slate-900">
            <div className="text-left space-y-1">
              <div className="font-mono text-[9px] text-slate-500 uppercase">Module</div>
              <div className="font-display font-extrabold text-slate-200 text-sm">Watchlist</div>
            </div>
            <div className="text-left space-y-1">
              <div className="font-mono text-[9px] text-slate-500 uppercase">Phase</div>
              <div className="font-display font-extrabold text-[#9d4edd] text-sm">Design</div>
            </div>
            <div className="text-left space-y-1">
              <div className="font-mono text-[9px] text-slate-500 uppercase">Tech</div>
              <div className="font-display font-extrabold text-[#00f0ff] text-sm">AI · APIs</div>
            </div>
            <div className="text-left space-y-1">
              <div className="font-mono text-[9px] text-slate-500 uppercase">ETA</div>
              <div className="font-display font-extrabold text-[#39ff14] text-sm">TBD</div>
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
};
